import { Routes } from '@angular/router';
import { PublicReportComponent } from './agency/agency-reports/public-report/public-report.component';
import { AuthCallbackComponent } from './authentication/auth-callback/auth-callback.component';
import { AuthMessageComponent } from './authentication/auth-message/auth-message.component';
import { LoginComponent } from './authentication/login/login.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { PasswordChangedComponent } from './authentication/password-changed/password-changed.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { AuthGuard, RoleTypeGuard } from './core/guards';
import { HomeComponent } from './home/home.component';
import { OpportunitiesComponent } from './opportunities/opportunities.component';
import { ConfirmAccountComponent } from './public/confirm-account/confirm-account.component';
import { ConfirmationSentComponent } from './public/confirmation-sent/confirmation-sent.component';
import { ContactComponent } from './public/contact/contact.component';
import { PrivacyPolicyComponent } from './public/privacy-policy/privacy-policy.component';
import { ConfirmEmailChangeComponent } from './settings/confirm-email-change/confirm-email-change.component';

export const routes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy',
      showMaster: false,
    },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'verify',
    component: SignUpComponent,
  },
  {
    path: 'password-changed',
    component: PasswordChangedComponent,
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'auth-msg',
    component: AuthMessageComponent,
  },
  {
    path: 'confirmation-sent/:vendorToken',
    component: ConfirmationSentComponent,
    data: {
      title: 'Confirmation Email Sent',
      showMaster: false,
    },
  },
  {
    path: 'account-confirmed/:vendorToken/:confirmationKey',
    component: ConfirmAccountComponent,
    data: {
      title: 'Confirm Account',
      showMaster: false,
    },
  },
  {
    path: 'opportunities',
    component: OpportunitiesComponent,
    data: {
      title: 'Opportunities',
      showMaster: true,
    },
  },
  {
    path: 'about',
    redirectTo: () => {
      window.open('https://www.colbitech.com/qualitybidders', '_blank');
      return '';
    },
  },
  {
    path: 'help',
    loadChildren: () => import('./public/help/help.routes').then(m => m.HELP_ROUTES),
  },
  {
    path: 'contacts',
    component: ContactComponent,
    data: {
      title: 'QualityBidders Contact Us',
      showMaster: true,
    },
  },
  {
    path: 'qbat',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard],
    data: {
      allowedRoles: ['qbat'],
    },
    loadChildren: () => import('./qbat/qbat.routes').then(m => m.QBAT_ROUTES),
  },
  {
    path: 'vendor',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard],
    data: {
      allowedRoles: ['vendor'],
    },
    loadChildren: () => import('./vendor/vendor.routes').then(m => m.VENDOR_ROUTES),
  },
  {
    path: 'agency',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard],
    data: {
      allowedRoles: ['agency'],
    },
    loadChildren: () => import('./agency/agency.routes').then(m => m.AGENCY_ROUTES),
  },
  // Same public report as below, but /pdf or /excel triggers a file download instead of the HTML table.
  {
    path: 'r/:agencyPrefix/:reportName/:format',
    component: PublicReportComponent,
  },
  {
    path: 'r/:agencyPrefix/:reportName',
    component: PublicReportComponent,
  },
  {
    path: 'settings',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () => import('./settings/settings.routes').then(m => m.SETTINGS_ROUTES),
  },
  {
    path: 'confirm-email-change/:confirmationKey',
    component: ConfirmEmailChangeComponent,
  },
  {
    path: 'admin',
    canLoad: [AuthGuard, RoleTypeGuard],
    canActivate: [AuthGuard, RoleTypeGuard],
    data: {
      allowedRoles: ['colbi'],
    },
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES),
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
